import { QUALTRICS_SURVEY_TYPES } from '../../helpers/qualtrics-feedback.constants';
import {
  QualtricsSubmitResponse,
  QualtricsSurvey,
  QualtricsSurveySubmit,
} from '../../models';

export class LoadQualtricsSurveyDetails {
  static readonly type = '[Qualtrics Feedback] Load Survey';

  constructor(
    public readonly surveyType: string = QUALTRICS_SURVEY_TYPES.ALWAYS_ON,
  ) {}
}

export class LoadQualtricsSurveyDetailsSuccess {
  static readonly type = '[Qualtrics Feedback] Load Survey Success';

  constructor(
    public readonly surveyType: string,
    public readonly survey: QualtricsSurvey | null,
  ) {}
}

export class LoadQualtricsSurveyDetailsError {
  static readonly type = '[Qualtrics Feedback] Load Survey Error';

  constructor(
    public readonly surveyType: string,
    public error: string,
  ) {}
}

export class SubmitQualtricsSurvey {
  static readonly type = '[Qualtrics Feedback] Submit Survey';

  constructor(
    public readonly surveyType: string,
    public readonly payload: QualtricsSurveySubmit,
  ) {}
}

export class SubmitQualtricsSurveySuccess {
  static readonly type = '[Qualtrics Feedback] Submit Survey Success';

  constructor(
    public readonly surveyType: string,
    public readonly response: QualtricsSubmitResponse,
  ) {}
}

export class SubmitQualtricsSurveyError {
  static readonly type = '[Qualtrics Feedback] Submit Survey Error';

  constructor(
    public readonly surveyType: string,
    public readonly errorMessage: string,
  ) {}
}
